if (!window.Eurus.loadedScript.has('locales-form.js')) {
  window.Eurus.loadedScript.add('locales-form.js');

  // Registrierung läuft normal über alpine:init (Script wird vor vendors.js/Alpine ausgeführt).
  // Läuft das Script erst nach dem Alpine-Start (z. B. als geklonter Script-Tag aus einem
  // <template>), wird die Komponente sofort registriert, damit spätere Klone funktionieren.
  const registerLocalizationForm = () => {
      Alpine.data('xLocalizationForm', () => ({ 
        openCountry: false,
        loading: false,
        cachedResults: false,
        submit(value, input) {
          this.$el.closest("#localization_form").querySelector('#'+input).value = value;
          this.$el.closest("#localization_form").submit();
        },
        loadCountry(el) {
          if (this.cachedResults) {
            this.openCountry = true;
            return true
          }
          let countrySelector = el.closest(".country-selector");
          let optionEL = countrySelector.querySelector(".country-options");

          this.loading = true;
          fetch(window.Shopify.routes.root + '?section_id=country-selector')
          .then(reponse => {
            return reponse.text();
          })
          .then((response) => {
            const parser = new DOMParser();
            const content = parser.parseFromString(response,'text/html').getElementById("list-country").innerHTML;
            optionEL.innerHTML = content;
            this.cachedResults = true;
            this.openCountry = true;
          })
          .finally(() => {
            this.loading = false;
          })
        },
      }))
  };
  if (window.Alpine) {
    registerLocalizationForm();
  } else {
    requestAnimationFrame(() => {
      document.addEventListener('alpine:init', registerLocalizationForm);
    });
  }
}